<template>
  <div @click="link(file.url)">
    <div
      class="flex cursor-pointer items-center p-3 bg-grey hover:bg-grey-light rounded-sm w-full lg:w-64 transition"
    >
      <img class="w-5 mr-3" src="~assets/images/ill/pdf.svg" alt="pdf icon" />
      <span class="truncate font-semibold text-sm text-blue-dark uppercase">
        <slot />
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  methods: {
    link(url) {
      window.open(url)
    },
  },
}
</script>

<style lang="scss" scoped></style>
